import { Page as CorePage, type PageComponentProps } from "@b2bportal/core-ui";

// Points balance fetching is now handled at the app level in Layout.tsx
// to prevent redundant API calls on every page navigation
export const Page = (props: PageComponentProps) => {
  return <CorePage {...props} />;
};
